export enum ExpireErrorCode {
  paymentRequired = "PAYMENT_REQUIRED",
  gon = "GONE",
}
